import { Switch } from '@headlessui/react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';

export interface Props {
  value: boolean;
  cursorClassName?: string;
  handleOnClick: () => void;
}

const ToggleButton: React.FC<Props> = ({
  value,
  handleOnClick,
  cursorClassName = 'cursor-pointer',
}) => {
  return (
    <Switch
      checked={value}
      onChange={handleOnClick}
      className={clsx(
        value ? 'bg-teal-600' : 'bg-gray-200',
        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer',
        'rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out',
        cursorClassName,
      )}
    >
      <span
        aria-hidden="true"
        className={clsx(
          value ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow',
          'ring-0 transition duration-200 ease-in-out',
        )}
      />
    </Switch>
  );
};

export default observer(ToggleButton);
